import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import * as forge from 'node-forge';


@Injectable()
export class DealerService {
  publicKey: string = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoRuUJ/00OTIh82a1EfXu
    Qp1QfPn3bQPSjt/7h3EvYceB/bCsLgofbKQ+kvwTSz0ERNKTcSB3XUvu02VMk5YK
    bkAIchEacdYFqDDnw9nACFZJn3qyJI/SF5m7JUiaf3KS2trUh+whCHBE/TzezBx+
    I+WNrOeCUdnd0XXuTIOyay9E+E//4nUZgmJ9XY/Jjb81sq1voxV6pVy1+BEel4BQ
    sBnAxNWEx9KTlpMjuHK2aqOkCNTTv5G0yefGdWcXIGdFXOhECE9b12p3Nc4OGx5d
    /LKb7m2kSeKjj1jPnjNHVDrnrzRnEcIKmDjwAL7FequkW3OYhmP/enuvYL55GTyA
    fwIDAQAB
    -----END PUBLIC KEY-----`;
    otpEncrypt: any;

  filter(arg0: (x: any) => boolean): any[] {
    throw new Error("Method not implemented.");
  }

    getEventRoute = '/api/dbtdealer/';

    constructor(private dataService: DataService) {
    };
    save(result: any) {
        return this.dataService.post('/api/dbtdealer/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    getdealerDetails(refresh: boolean) {
        return this.dataService.getData('/api/dbtdealer', refresh);
    }
    getdealerDetailslist(id, refresh: boolean) {
        return this.dataService.getData('/api/dbtdealer/' + id, refresh);
    }


    getdealerManufacturerlist(id, refresh: boolean) {
        return this.dataService.getData('/api/dbtdealer/manufacturerlist/' + id, refresh);
    }

    getDealerTreeChart(id: number, refresh: boolean) {
        return this.dataService.getData(
          "/api/dbtdealer/dealerinfotreechartDetail/" + id,
          refresh
        );
      }

      getDealerTreeChartflow(id: number,isAllDistrict:boolean,year:any, refresh: boolean) {
        return this.dataService.getData(
          "/api/dbtdealer/dealerinfotreechart/" + id + '/' +  isAllDistrict + '/' + year ,
          refresh
        );
      }
      getDealerInfo(id: number,year:any, refresh: boolean) {
        return this.dataService.getData(
          "/api/dbtdealer/dealerinfotreechart/" + id + '/' + year ,
          refresh
        );
      }

      dealerApproval(result: any) {
        return this.dataService
          .post("/api/dbtdealer/dealerapproval", result)
          .map((response) => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
          });
      }

      dealerWidrawal(result: any) {
        return this.dataService
          .post("/api/dbtdealer/dealerunblock", result)
          .map((response) => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
          });
      }

    getdealerDetailsByGstlist(gstNo, refresh: boolean) {
        return this.dataService.getData('/api/dbtdealer/detail/' + gstNo, refresh);
    }
    getdealerAlllist(refresh: boolean) {
        return this.dataService.getData('/api/dbtdealer/dealerList', refresh);
    }
    getmanufacturerAlllist(refresh: boolean) {
        return this.dataService.getData('/api/dbtmanufacturer/manufacturerList', refresh);
    }
    getdealermanufacturer(refresh: boolean) {
      return this.dataService.getData('/api/dbtdealer/manufacturerList', refresh);
  }

  getdealerproduct(refresh: boolean) {
    return this.dataService.getData('/api/dbtproduct/productlistbydealer', refresh);
}
    
    update(result: any) {
        return this.dataService.post('/api/dbtdealer/Update', result).map(res => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return res;
        }
        );
    }
    sendOtp(result :any){
      return this.dataService.post('/api/dbtdealer/generateotp', result).map(response => {
        return response;
      });
      }
      OtpVerification(result: any, refresh: boolean) {
              if(result){
              var rsa = forge.pki.publicKeyFromPem(this.publicKey);
              // var encryptedPassword = window.btoa(rsa?.encrypt(result?.enteredOtp));
              const data = {
                  id: result.id,
                  otp: result.enteredOtp
              }
              return this.dataService.post('/api/dbtdealer/verifyotp', data).map(response => {
                  return response;
              });
            }
           
          }
    delete(id: number, status: number) {
        return this.dataService.post('/api/dbtdealer/delete/' + id + '/' + status, null).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    getbyDealerTimeLine(id: number,refresh: boolean) {
      return this.dataService.getData(
        '/api/dbtdealer/timeline/'+id, refresh
      );
    }
    addadress(result: any) {
      return this.dataService.post('/api/dbtdealer/dealeraddressupdate', result).map(response => {
          this.dataService.clearRouteCache(this.getEventRoute);
          return response;
      }); 
  }

    updateGstDetails(result: any) {
      return this.dataService.post('/api/dbtdealer/updategst', result).map(response => {
          this.dataService.clearRouteCache(this.getEventRoute);
          return response;
      });
  }
}
